<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('room_bed_availability')" :is-filter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('room_bed_availability')" :is-filter="false"/>
            </template>
            <div class="filter">
                <h6>{{ $t('filter1').toUpper() }}</h6>
                <div class="border rounded p-4 pb-0 mb-4">
                    <b-row>
                        <b-col cols="6" md="4" lg="3">
                            <b-form-group :label="$t('housing_building')">
                                <house-building-selectbox v-model="formData.housing_building_id" />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" md="4" lg="3">
                            <b-form-group :label="$t('date')" class="position-relative">
                                <v-date-picker
                                    v-model="formData.date"
                                    :locale="'en'"
                                    is-expanded
                                    :mask="{ input: 'MM/DD/YYYY' }"
                                    :popover="{ visibility: 'click' }"
                                >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <b-input-group>
                                            <b-form-input :readonly="true" :value="inputValue" v-on="inputEvents"></b-form-input>
                                            <b-input-group-append>
                                                <b-button variant="outline-secondary" class="btn-40" disabled>
                                                    <i class="ri-calendar-line"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </template>
                                </v-date-picker>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <b-table
                v-if="filteredData && filteredData.length > 0"
                :empty-filtered-text="$t('no_result')"
                :empty-text="$t('no_result')"
                bordered
                responsive
                thead-class="d-none"
                :items="filteredData"
                :fields="filteredDataFields"
                :tbody-tr-class="rowClass"
                show-empty
                class="mb-4 table-dropdown no-scrollbar border rounded"
                @row-clicked="onRowClicked"
            >
                <template #cell(floor)="{ item }">
                    <div class="d-flex justify-content-center align-items-center">
                        <strong class="font-size-16">
                            {{ item.floor }}
                        </strong>
                    </div>

                </template>
                <template #cell(detail)="data">
                    <div class="w-40 h-40 cursor-pointer d-flex justify-content-center align-items-center">
                        <i :class="data.detailsShowing ? 'ri-arrow-up-s-line font-size-20' : 'ri-arrow-down-s-line font-size-20'"></i>
                    </div>
                </template>
                <template #row-details="data">
                    <div class="bg-white m-2">
                        <b-table-simple class="table table-bordered m-0">
                            <b-tbody>
                                <b-tr>
                                    <b-td v-for="(room, roomKey) in data.item.rooms" :key="'room' + roomKey" class="d-none d-lg-table-cell print align-middle">
                                        <h6 class="text-center">{{room.room_name}} ({{room.gender}})</h6>
                                        <b-table-simple v-if="room.beds && room.beds.length > 0" class="table-bordered table-striped table-sm">
                                            <b-col cols="12" class="border p-4">
                                                <b-row v-for="(studentGroup, groupIndex) in chunkedStudents(room.beds, 4)" :key="'group' + groupIndex" class="mb-3">
                                                    <b-col
                                                        class="p-3 text-center text-white text-wrap ml-2 mr-2 width-50 height-80"
                                                        :style="'background-color:' + (student.email ? 'red' : (student.future_reservation ? 'orange' : 'green')) + ';cursor:' + ((student.email || student.future_reservation)?'pointer':'not-allowed')"
                                                        v-for="(student, studentKey) in studentGroup"
                                                        :key="'student' + studentKey"
                                                        @click="student ? showUserModal(student.future_reservation_detail??student):''"

                                                    >
                                                        {{ student.bed }}
                                                        <div v-if="student.future_reservation">{{student.future_reservation}}</div>
                                                        <div v-else-if="student.check_in_date">{{student.check_in_date}} - {{student.check_out_date}}</div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>

                                        </b-table-simple>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </template>
            </b-table>
        </app-layout>
        <CommonModal size="md" ref="userDetail" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
            <template v-slot:CommonModalTitle>
                <div>{{$t('student_making_reservation').toUpperCase()}}</div>
            </template>
            <template v-slot:CommonModalContent>
                <b-row>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('name')">
                            <b-input-group>
                                <div class="label-as-input">{{ isNotNullValue(userData.name) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('surname')">
                            <b-input-group>
                                <div class="label-as-input">{{ isNotNullValue(userData.surname) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('tenant_type')">
                            <b-input-group>
                                <div class="label-as-input">{{ isNotNullValue(userData.tenant_type) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('gender')">
                            <b-input-group>
                                <div class="label-as-input">{{ isNotNullValue(userData.gender) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('check_in_date')">
                            <b-input-group>
                                <div class="label-as-input">{{ isNotNullValue(userData.check_in_date) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('check_out_date')">
                            <b-input-group>
                                <div class="label-as-input">{{ isNotNullValue(userData.check_out_date) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('room_type_name')">
                            <b-input-group>
                                <div class="label-as-input">{{ isNotNullValue(userData.room_type_name) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

            </template>
        </CommonModal>
    </div>
</template>

<script>
import AppLayout from '@/layouts/AppLayout';
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';
import qs from 'qs';
import RoomBedAvailabilityServices from '@/services/RoomBedAvailabilityServices';
import HouseBuildingSelectbox from '@/components/interactive-fields/HouseBuildingSelectbox.vue';
import moment from 'moment';

export default {
    components: {
        HouseBuildingSelectbox,
        AppLayout,
        HeaderMobile,
    },
    metaInfo() {
        return {
            title: this.$t('room_bed_availability')
        };
    },
    created() {
        this.getCurrentDate();
    },
    data() {
        return {
            userData:{
                name:null,
                surname:null,
                flor:null,
                gender:null,
                room_type_name:null,
                tenant_type:null,
                check_in_date:null,
                check_out_date:null,
            },
            formId: null,
            formData: {
                housing_building_id: null,
                date: null
            },
            formProcess: null,
            filteredData: [],
            filteredDataFields: [
                {
                    key: 'floor',
                    tdClass: 'align-middle'

                },
                {
                    key: 'detail',
                    label: ' ',
                    class: this.moveMode ? 'width-150 p-1 align-middle' : 'w-40 p-1 align-middle'
                }
            ]
        };
    },
    watch: {
        'formData.housing_building_id'(newVal, oldVal) {
            if (newVal != null && newVal !== oldVal) {
                this.getRows();
            }
        },
        'formData.date'(newVal, oldVal) {
            if (newVal != null && newVal !== oldVal && this.formData.housing_building_id != null) {
                this.getRows();
            }
        }
    },
    methods: {
        formClear() {
          this.userData = {};
        },
        chunkedStudents(students, size) {
            if (!students || !Array.isArray(students)) return [];
            const result = [];
            for (let i = 0; i < students.length; i += size) {
                result.push(students.slice(i, i + size));
            }
            return result;
        },
        getCurrentDate() {
            const date = new Date();
            this.formData.date = moment(date).format('MM/DD/YYYY');
        },
        getRows() {
            this.filteredData = [];
            const config = {
                params: {
                    date: moment(this.formData.date).format('MM/DD/YYYY'),
                    id: this.formData.housing_building_id
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return RoomBedAvailabilityServices.getAll(config)
                .then((response) => {
                    const data = response.data.data;
                    const floorMap = {};
                    Object.entries(data).forEach(([floor, rooms]) => {
                        floorMap[floor] = floorMap[floor] || {floor, rooms: [],_showDetails: true};
                        Object.entries(rooms).forEach(([roomName, students]) => {
                            floorMap[floor].rooms.push({
                                room_name: roomName,
                                gender: students[0].gender,
                                beds: students
                            });
                        });
                    });

                    this.filteredData = Object.values(floorMap);
                })
                .catch((error) => {
                    this.showErrors(error);
                });
        },
        rowClass(item, type) {
            if (!item || type !== 'row') {
                return;
            }
        },
        onRowClicked(item, index, event) {
            this.$set(item, '_showDetails', !item._showDetails);
        },
        showUserModal(student){
            this.userData={
                name:student.name,
                surname:student.surname,
                floor:student.floor,
                gender:student.gender,
                room_type_name:student.room_type_name,
                tenant_type:student.tenant_type,
                check_in_date:student.check_in_date,
                check_out_date:student.check_out_date,
            }
            this.$refs.userDetail.$refs.commonModal.show()

        }
    }
};
</script>

<style>
.table-slot-bg--green {
    background-color: #D9F2D0;
    border: 1px solid white;
}

.table-slot-bg--red {
    background-color: #FF9393;
}
</style>
